/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the SubmissionBlocker interface.
 */
export function instanceOfSubmissionBlocker(value) {
    return true;
}
export function SubmissionBlockerFromJSON(json) {
    return SubmissionBlockerFromJSONTyped(json, false);
}
export function SubmissionBlockerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}
export function SubmissionBlockerToJSON(json) {
    return SubmissionBlockerToJSONTyped(json, false);
}
export function SubmissionBlockerToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
        'message': value['message'],
    };
}
